var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"v:label":"valueLocal.name","type":"date"},model:{value:(_vm.valueLocal.value),callback:function ($$v) {_vm.$set(_vm.valueLocal, "value", $$v)},expression:"valueLocal.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }